export default __webpack_public_path__ + "static/media/cockpit-Header-HD.db1d4b46.jpg";